import { useEffect } from "react"
import { SeonReq } from "../../request/fraud.req"
import { FraudService } from "../../service/fraud.service"
import { useQueryParam, StringParam } from 'use-query-params';

export const useSeon = () => {
    const [loanId, setLoanId] = useQueryParam('loanId', StringParam);
    const [checkoutId, setCheckoutId] = useQueryParam('checkoutId', StringParam);

    useEffect(() => {
        const seon = (window as any).seon;
        if (seon) {
            seon.init();
        }
    }, []);

    useEffect(() => {
        const seon = (window as any).seon;
        if (loanId && loanId != 'undefined' && loanId.length > 0 && seon) {
            seon.getSession().then((sessionId: string) => {
                FraudService.updateSeonData(checkoutId ? checkoutId : '', {
                    sessionId
                });
            });
        }
    }, [loanId]);
};